import { useEffect, useState } from 'react';
import { getLandingPage } from '../../../api/portalServices';
import type { GetLandingPageResponse, PurchasedProduct } from '../../../api/types';
import { useSession } from '../../../common/authorization/context/Session';
import { AppError } from '../../../errorHandler/errors';
import { ProductCard } from './cards/ProductCard';
import { UnpurchasedProductCard } from './cards/UnpurchasedProductCard';
import './PortalLanding.less';
import DefaultLogo from '../../../assets/default_logo.svg';
import { useErrorContext } from '../../../errorHandler/context/ErrorContext';

export const PortalLanding = () => {
  const { emitError } = useErrorContext();
  const [data, setData] = useState<GetLandingPageResponse>();
  const { tenantId, workflowId } = useSession();
  const [isLoading, setIsLoading] = useState<boolean>();

  useEffect(() => {
    const getPortalInfo = async () => {
      return await getLandingPage(workflowId || '', tenantId || '');
    };
    setIsLoading(true);
    getPortalInfo()
      .then((response) => {
        setData(response);
      })
      .catch((e) => {
        emitError(new AppError(e));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [workflowId, tenantId, emitError]);

  // TODO: Remove this when local testing fixes the return of "string" for logos
  const resolvedLogoUrl =
    (data?.orgInfo?.logoUrl && data?.orgInfo?.logoUrl !== 'string' && data.orgInfo.logoUrl) || undefined;

  const purchasedProducts = data?.productInfo?.purchasedProducts;
  const nonPurchasedProducts = data?.productInfo?.nonPurchasedProducts;

  return (
    <>
      <section className="section title-bar content-title">
        <div className="product-container">
          <h1 className="h1">Imprivata Access Management</h1>
          {!isLoading && (
            <div>
              <img src={resolvedLogoUrl || DefaultLogo} alt="" />
            </div>
          )}
        </div>
      </section>
      {!!purchasedProducts?.length && (
        <section className="section purchased-cards">
          {purchasedProducts.map((product: PurchasedProduct) => (
            <ProductCard key={product.productTag} product={product} tenantId={tenantId || ''} />
          ))}
        </section>
      )}
      {!!nonPurchasedProducts?.length && (
        <section className="section unpurchased-cards">
          {nonPurchasedProducts.map((product) => (
            <UnpurchasedProductCard
              key={product.productTag}
              productName={product.displayName}
              productLink={product.learnMoreUrl}
            />
          ))}
        </section>
      )}
    </>
  );
};
